// extracted by mini-css-extract-plugin
export default {"modalOverlay":"mC-z","modalContent":"nC-z","header":"oC-z","close":"pC-z"};